export default function title(state) {
    const title = "SF State University";
    if (state.title) return state.title + " - " + title;
    return title;
}